import type { Links } from '@which/seatbelt'
import { MultiLinkBlock } from '@which/seatbelt'

import type { RecommendedContentType } from '../../models'
import styles from './RecommendationsTextLinksLayout.module.scss'

const getLinks = ({
  recommendations,
  sectionTitle,
  whichId,
  modelId,
  position,
}: {
  recommendations: RecommendedContentType[]
  sectionTitle: string
  whichId: string
  modelId: string
  position?: string
}) => {
  const links = recommendations.map((recommendation, index): Links[number] => {
    const title = recommendation.__typename == 'RecommendedArticle' ? recommendation.title : ''

    const link: Links[number] = {
      type: 'standard',
      href: recommendation.href,
      text: title,
      'data-which-id': whichId,
      'data-section': sectionTitle,
      'data-card-name': title,
      'data-index': (index + 1).toString(),
      'data-content-id': recommendation.id,
      'data-model-id': modelId,
      'data-spec': position,
      'data-personalisation': 'true',
    }

    return link
  })

  return links
}

type RecommendationsTextLinksLayoutProps = {
  recommendations: RecommendedContentType[]
  title: string
  whichId: string
  modelId: string
  position?: string
}

export const RecommendationsTextLinksLayout = ({
  recommendations,
  title,
  whichId,
  modelId,
  position,
}: RecommendationsTextLinksLayoutProps) => (
  <MultiLinkBlock
    title={title}
    links={getLinks({ recommendations, sectionTitle: title, whichId, position, modelId })}
    className={styles.recommendationTextLinks}
  />
)
